import React from "react";
import logoImage from "../assets/images/mobileLogo.png";
import "./Logo.css";

const Logo = (props) => {
  return <img src={logoImage} alt="TAPP" className="mobile-logo" {...props} />;
};

export default Logo;
